<!-- 家庭信息 -->
<template>
  <div class="family">
    <h1 class="application-title">家庭信息</h1>
    <Form ref="formValidate"
          :model="formValidate"
          :rules="ruleValidate">
      <div class="family-form">
        <div class="dis-30">
          <div class="application-order-title">
            1. Family information references - who are you thinking of asking?
          </div>
          <!-- <div class="dis-30 w720">
            <FormItem label="Father’s name"
                      prop="name"
                      :label-width="226">
              <Input v-model="formValidate.name"
                     placeholder="e.g. Xu Wang"></Input>
            </FormItem>
            <FormItem label="Father’s level of education"
                      prop="name"
                      :label-width="226">
              <Input v-model="formValidate.name"
                     placeholder="e.g. Masters"></Input>
            </FormItem>
            <FormItem label="Mother’s name"
                      prop="name"
                      :label-width="226">
              <Input v-model="formValidate.name"
                     placeholder="e.g. Xia Wang"></Input>
            </FormItem>
            <FormItem label="Mother’s level of education"
                      prop="name"
                      :label-width="226">
              <Input v-model="formValidate.name"
                     placeholder="e.g. Masters"></Input>
            </FormItem>
          </div> -->
          <div class="label-bot-20">
            <FormItem label="If your parents' profession has anything to do with your major selection, please specify"
                      prop="parentsJobAffect">
              <Input v-model="formValidate.parentsJobAffect"
                     placeholder="Please limit your response to 50 words"
                     type="textarea"
                     :rows="5"> </Input>
            </FormItem>
          </div>
        </div>
        <div class="dis-30 label-bot-20">
          <FormItem label="2. Have you had to overcome any personal or professional hardships? If yes, please describe in detail"
                    prop="conquerDifficultyUndergo">
            <Input v-model="formValidate.conquerDifficultyUndergo"
                   placeholder="Please limit your response to 250 words"
                   type="textarea"
                   :rows="5"> </Input>
          </FormItem>
        </div>
        <div class="dis-30 label-bot-20">
          <FormItem label="3. Have you ever undertaken paid employment during your studies (during term time)? If yes, please describe in detail"
                    prop="workExperience">
            <Input v-model="formValidate.workExperience"
                   placeholder="Please limit your response to 250 words"
                   type="textarea"
                   :rows="5"> </Input>
          </FormItem>
        </div>
        <div class="dis-30 label-bot-20">
          <FormItem label="4. Describe at least one 'defining moment' in your life. If yes, please describe in detail"
                    prop="crisis">
            <Input v-model="formValidate.crisis"
                   placeholder="Please limit your response to 250 words"
                   type="textarea"
                   :rows="5"> </Input>
          </FormItem>
        </div>
        <div class="dis-40">
          <div class="application-order-title dis-10">
            5. Experiences, books, conversations, that have impacted you and made you think about your current path or future goals
          </div>
          <div class="dis-40"
               v-for="(item, index) in formValidate.influenceOneselfUndergos"
               :key="index">
            <div class="dis-30 label-bot-20">
              <div class="delete"
                   v-if="index!=0"
                   @click="removeInfluenceOneselfUndergo(index)"
                   style="top: -10px;z-index:100;"></div>
              <FormItem :label="'Experience '+(index+1)"
                        prop="name">
                <Input v-model="formValidate.influenceOneselfUndergos[index]"
                       placeholder="Please limit your response to 100 words"
                       type="textarea"
                       :rows="5"> </Input>
              </FormItem>
            </div>
          </div>
          <div class="application-order-add"
               @click="addInfluenceOneselfUndergo">添加更多 Experience</div>
        </div>
        <div class="dis-40">
          <div class="application-order-title dis-10">
            6. What personal qualities do you believe make you unique?
          </div>
          <div class="dis-40"
               v-for="(item, index) in formValidate.haveQualitys"
               :key="index">
            <div class="dis-30 label-bot-20">
              <div class="delete"
                   v-if="index!=0"
                   @click="removeHaveQuality(index)"
                   style="top: -10px;z-index:100;"></div>
              <FormItem :label="'Quality '+(index+1)"
                        prop="name">
                <Input v-model="formValidate.haveQualitys[index]"
                       placeholder="Please limit your response to 100 words"
                       type="textarea"
                       :rows="5"> </Input>
              </FormItem>
            </div>
          </div>
          <div class="application-order-add"
               @click="addHaveQuality">添加更多 Quality</div>
        </div>
        <div class="dis-40">
          <div class="application-order-title dis-20">
            7. How would your friends describe you? Provide 3 adjectives
          </div>
          <div class="dis-40"
               v-for="(item, index) in formValidate.describeYourself"
               :key="index">
            <div class="dis-30 label-bot-20">
              <div class="delete"
                   v-if="index!=0"
                   @click="removeDescribeYourself(index)"
                   style="top: -10px;z-index:100;"></div>
              <FormItem :label="'Adjective '+(index+1)"
                        prop="name">
                <Input v-model="formValidate.describeYourself[index]"
                       placeholder="Please limit your response to 100 words"
                       type="textarea"
                       :rows="5"> </Input>
              </FormItem>
            </div>
          </div>
          <div class="application-order-add"
               @click="addDescribeYourself">添加更多 Adjective</div>
        </div>
        <div class="dis-0">
          <div class="application-order-title dis-10">
            8. Who are the top 2 people who have impacted or influenced you? Why? (you don't have to know them personally)
          </div>
          <div class="dis-40"
               v-for="(item, index) in formValidate.affectHumans"
               :key="index">
            <div class="label-bot-20">
              <div class="delete"
                   v-if="index!=0"
                   @click="removeAffectHuman(index)"
                   style="top: -10px;z-index:100;"></div>
              <FormItem label="Person and why？"
                        prop="name">
                <Input v-model="item.description"
                       placeholder="Please limit your response to 100 words"
                       type="textarea"
                       :rows="5"> </Input>
              </FormItem>
            </div>
          </div>
          <div class="application-order-add"
               @click="addAffectHuman">添加更多 Person</div>
        </div>
        <div class="sub-btn" v-if="isallowedit">
          <Affix :offset-bottom="20">
            <Button type="primary"
                    style="width:96px;"
                    @click="saveHandle">保存</Button>
          </Affix>
        </div>
      </div>
    </Form>
  </div>
</template>

<script>
import isAllowEdit from '@/view/mixins/is-edit'
//  api
import { infoQueryFamily, infoModifyFamily } from '@/api/info'
export default {
  name: 'application-family',
  mixins: [isAllowEdit],
  components: {},
  data () {
    return {
      formValidate: {},
      ruleValidate: {}
    }
  },
  computed: {},
  mounted () {
    this.getInfo()
  },
  methods: {
    getInfo () {
      infoQueryFamily().then(res => {
        let data = res.data.model || {}

        this.formValidate = Object.assign({}, data)

        this.$set(this.formValidate, 'influenceOneselfUndergos', data.influenceOneselfUndergos || [''])
        this.$set(this.formValidate, 'haveQualitys', data.haveQualitys || [''])
        this.$set(this.formValidate, 'describeYourself', data.describeYourself || [''])
        this.$set(this.formValidate, 'affectHumans', data.affectHumans || [{}])
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    },
    saveHandle () {
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          let data = Object.assign({}, this.formValidate)
          infoModifyFamily(data).then(res => {
            this.$zlr_message('保存成功', 'success')
          }).catch(error => {
            this.$zlr_message(error.message, 'error')
          })
        }
      })
    },
    addAffectHuman () {
      this.formValidate.affectHumans.push({
        name: '',
        description: ''
      })
    },
    removeAffectHuman (index) {
      this.formValidate.affectHumans.splice(index, 1)
    },
    addInfluenceOneselfUndergo () {
      this.formValidate.influenceOneselfUndergos.push('')
    },
    removeInfluenceOneselfUndergo (index) {
      this.formValidate.influenceOneselfUndergos.splice(index, 1)
    },
    addHaveQuality () {
      this.formValidate.haveQualitys.push('')
    },
    removeHaveQuality (index) {
      this.formValidate.haveQualitys.splice(index, 1)
    },
    addDescribeYourself () {
      this.formValidate.describeYourself.push('')
    },
    removeDescribeYourself (index) {
      this.formValidate.describeYourself.splice(index, 1)
    }
  }
}
</script>
<style lang='less' scoped>
</style>
